/*
  Inspiration build video modal — extracted from snippets/inspiration.liquid and
  snippets/inspiration-2026.liquid (the two blocks were byte-identical) so it ships from one
  cacheable, deferred asset instead of inline markup.
*/

var modalLinks = document.querySelectorAll('.modalLink');
for (let i = 0; i < modalLinks.length; i++) {
  modalLinks[i].addEventListener("click", function() {
    document.getElementById(modalLinks[i].dataset.modal).classList.add('cc-popup--visible');
    document.body.classList.add('cc-modal-visible');
    document.getElementById('gg-inject-inspiration-video').innerHTML = document.getElementById(modalLinks[i].dataset.video).innerHTML;
  });
}

var closeModalLinks = document.querySelectorAll('.cc-popup-close-gg');
for (let i = 0; i < closeModalLinks.length; i++) {
  closeModalLinks[i].addEventListener("click", function() {
    document.getElementById(closeModalLinks[i].dataset.modalclose).classList.remove('cc-popup--visible');
    document.body.classList.remove('cc-modal-visible');
    document.getElementById('gg-inject-inspiration-video').innerHTML = '';
  });
}

var closeModalLinksViaBG = document.querySelectorAll('.cc-popup-background');
for (let i = 0; i < closeModalLinksViaBG.length; i++) {
  closeModalLinksViaBG[i].addEventListener("click", function() {
    document.getElementById(closeModalLinksViaBG[i].dataset.modalclose).classList.remove('cc-popup--visible');
    document.body.classList.remove('cc-modal-visible');
    document.getElementById('gg-inject-inspiration-video').innerHTML = '';
  });
}
